var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';
import removeKeys from '../utils/removeKeys';
/**
DragHandle - A wrapper component to make the child content a handle for a draggable container.
Designed to be used as a direct child of a DragContainer component.
**/
const DragHandle = props => {
    const _a = removeKeys(props, ['classes']), { dragStart, children } = _a, rest = __rest(_a, ["dragStart", "children"]);
    return React.createElement("div", Object.assign({}, rest, resolveTestId(props), resolve(props, 'dragHandle'), { onMouseDown: dragStart }), children);
};
DragHandle.propTypes = {
    /** Callback function to execute on mouse down (should start drag action).  */
    dragStart: PropTypes.func,
    /** The child content for the container. */
    children: PropTypes.node,
    /** Available Style Keys. */
    style: PropTypes.shape({
        /** Top level style applied to the container. */
        dragHandle: PropTypes.object
    })
};
DragHandle.displayName = 'DragHandle';
export default DragHandle;
